import { render, staticRenderFns } from "./PizzaNeeded.vue?vue&type=template&id=b83074ac"
import script from "./PizzaNeeded.vue?vue&type=script&lang=ts"
export * from "./PizzaNeeded.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports